import { combineReducers } from 'redux';

import geraSenha from './geraSenha/reducer';

export default combineReducers({
	geraSenha,
});
